import { baseThemeShadows } from './shadows'
import whiteLabelBaseTheme, { whiteLabelBaseBorderRadii, whiteLabelBaseDefaultPalette } from './whiteLabelBase'

export const dealsTravelDefaultPalette: App.Design.Palette<string> = {
  ...whiteLabelBaseDefaultPalette,
}

export const dealsTravelShadows: App.Design.Shadows<string> = { ...baseThemeShadows }
export const dealsTravelBorderRadii: App.Design.BorderRadii<string> = { ...whiteLabelBaseBorderRadii }

const dealsTravelTheme: App.Design.Theme = {
  ...whiteLabelBaseTheme,
}

export default dealsTravelTheme
